import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Settings, Monitor } from 'lucide-react';

export default function MobileSettingsPage() {
  const navigate = useNavigate();

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 16 }}>Settings</div>

      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">App Info</div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">App</span><span className="mobile-detail-value">Rudder Mobile</span></div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Version</span><span className="mobile-detail-value">1.0.0</span></div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Platform</span><span className="mobile-detail-value">PWA</span></div>
      </div>

      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">User</div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Name</span><span className="mobile-detail-value">John Doe</span></div>
        <div className="mobile-detail-row"><span className="mobile-detail-label">Role</span><span className="mobile-detail-value">Plant Manager</span></div>
      </div>

      <button className="mobile-action-btn" style={{ background: '#f2f2f7', color: '#007aff', marginTop: 12 }} onClick={() => navigate('/')}>
        <Monitor size={18} /> Open Desktop View
      </button>
    </div>
  );
}
